import { useBusinessInfo } from '@/hooks/useBusinessInfo';

export default function FloatingButtons() {
  const { info, waLink } = useBusinessInfo();

  return (
    <div className="fixed bottom-6 right-5 z-50 flex flex-col gap-3">
      {/* WhatsApp */}
      {info.whatsapp && (
        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full cursor-pointer transition-all duration-200 hover:scale-110 animate-pulse-slow"
          aria-label="Chat on WhatsApp"
          title="Order on WhatsApp"
        >
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </a>
      )}
      {/* Call */}
      {info.phone && (
        <a
          href={`tel:${info.phone.replace(/\D/g, '')}`}
          className="w-14 h-14 flex items-center justify-center bg-[#F57F25] hover:bg-[#e06d15] rounded-full cursor-pointer transition-all duration-200 hover:scale-110"
          aria-label="Call Bucara Burger"
          title="Call Us"
        >
          <i className="ri-phone-line text-black text-2xl"></i>
        </a>
      )}
    </div>
  );
}
